import React from 'react';

export function ComparisonCard({ title, leftLabel = 'A', rightLabel = 'B', rows = [] }) {
  return (
    <div style={{ margin: '10px 0 14px', padding: '14px 16px', background: 'rgba(6,14,40,0.55)', border: '1px solid rgba(56,189,248,0.12)', borderRadius: 12, fontFamily: 'inherit' }}>
      {title && (
        <span style={{ fontSize: 9.5, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(56,189,248,0.55)', display: 'block', marginBottom: 10 }}>
          {title}
        </span>
      )}

      {/* Column headers */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12, paddingBottom: 8, borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <span style={{ fontSize: 11.5, color: '#818cf8', fontWeight: 600 }}>{leftLabel}</span>
        <span style={{ fontSize: 11.5, color: '#38bdf8', fontWeight: 600 }}>{rightLabel}</span>
      </div>

      {/* Rows */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {rows.map((row, i) => {
          const l = Math.min(100, Math.max(0, typeof row.left === 'number' ? (row.left > 10 ? row.left : row.left * 10) : 50));
          const r = Math.min(100, Math.max(0, typeof row.right === 'number' ? (row.right > 10 ? row.right : row.right * 10) : 50));
          return (
            <div key={i}>
              <span style={{ fontSize: 11, color: 'rgba(172,196,236,0.6)', display: 'block', marginBottom: 4, textAlign: 'center' }}>{row.label}</span>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                <div style={{ flex: 1, height: 4, background: 'rgba(255,255,255,0.06)', borderRadius: 2, overflow: 'hidden', direction: 'rtl' }}>
                  <div style={{ width: `${l}%`, height: '100%', background: '#818cf8', borderRadius: 2, transition: 'width .8s ease' }} />
                </div>
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.2)', flexShrink: 0 }}>│</div>
                <div style={{ flex: 1, height: 4, background: 'rgba(255,255,255,0.06)', borderRadius: 2, overflow: 'hidden' }}>
                  <div style={{ width: `${r}%`, height: '100%', background: '#38bdf8', borderRadius: 2, transition: 'width .8s ease' }} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
